var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{ref:"noopener noreferrer",class:['icon', _vm.name+'-icon-'+_vm.division],attrs:{"href":_vm.link,"target":"_blank"}})}
var staticRenderFns = []

export { render, staticRenderFns }